import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);
import { SaveToSessionStorage, GetFromSessionStorage,SaveToLocalStorage,GetFromLocalStorage } from '@/utils/index'
export default new Vuex.Store({
  state:{
    chats:[],
    token:'',
    docList:GetFromSessionStorage('doc_list',2) || [],
    find_doc_list:GetFromSessionStorage('find_doc_list',2) || [],
    chat_list:GetFromLocalStorage('chat_list',2) || [],
    isIphoneX:GetFromSessionStorage('isIphoneX',2) || false,
    scroll_top:GetFromSessionStorage('scroll_top',2) || 0,
    group_id:GetFromSessionStorage('group_id',2) || '',
    huiid:'',
    videodoctor:'',
    videoing:false,
    videoGroup:'',
    router_back:GetFromSessionStorage('router-back',2) || ''
  },
  mutations:{
    setRouterBack(state,data){
      state.router_back = data;
    },
    updateChats(state,newChat){
      newChat.timestamp = newChat.time;
      state.chats.push(newChat)
    },
    getChat(state,oldChats){
      state.chats.unshift(oldChats);
    },
    setToken(state,newToken){
      console.log('newToken:'+newToken)
      state.token = newToken;
    },
    setDocList(state,data){
      state.docList = data;
    },
    setFindDocList(state,data){
      state.find_doc_list = data;
    },
    setChatList(state,data){
      state.chat_list = data;
    },
    setIphoneX(state,data){
      state.isIphoneX = data;
    },
    setScrollTop(state,data){
      state.scroll_top = data;
    },
    setGroupId(state,data){
      state.group_id = data;
    },
    setHuiId(state,data){
      state.huiid = data;
    },
    setVideoDoctor(state,data){
      state.videodoctor = data;
    },
    setVideoing(state,data){
      state.videoing = data;
    },
    setVideoGroup(state,data){
      state.videoGroup = data;
    }
  },
  actions:{
    getRouterBack({commit},data){
      SaveToSessionStorage('router-back',data);
      commit('setRouterBack',data);
    },
    // 对话房间的id
    getGroupId({commit},data){
      commit('setGroupId',data);
      SaveToSessionStorage('group_id',data)
    },
    getDocList({commit},data){
      commit('setDocList',data)
      SaveToSessionStorage('doc_list',data)
    },
    getFindDocList({commit},data){
      commit('setFindDocList',data)
      SaveToSessionStorage('find_doc_list',data)
    },
    getChatList({commit},data){
      commit('setChatList',data)
      SaveToLocalStorage('chat_list',data)
    },
    getIphoneX({commit},data){
      commit('setIphoneX',data);
      SaveToSessionStorage('isIphoneX',data)
    },
    getScrollTop({commit},data){
      commit('setScrollTop',data);
      SaveToSessionStorage('scroll_top',data)
    }
  },
  getters:{
    getToken: state => {
      return state.token
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js